import { createStore } from 'redux';
import reducer from './reducer';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { encryptTransform } from 'redux-persist-transform-encrypt';

// ==============================|| REDUX - MAIN STORE ||============================== //
const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['auth'],
    transforms: [
        encryptTransform({
            secretKey: process.env.REACT_APP_SECRET_ENCRYPT,
            onError: function (error) {
                // Handle the error.
            }
        })
    ]
};
const persistedReducer = persistReducer(persistConfig, reducer);

const store = createStore(persistedReducer);
let persistor = persistStore(store);
export { store, persistor };
